/**
 * This file is currently not in use
 **/
import { useEffect } from 'react';
import DataTable from 'react-data-table-component';

import useWfWorkplaceService from 'src/api/wf/service/WfWorkplaceService';
import { useWfWorkplaceStore } from 'src/api/wf/stores/WfWorkplaceStore';
import { customStyles, getWfDataSummaryColumns } from './WF_4_8_1_DataSummaryColumns';
import { useTranslation } from 'react-i18next';

function WF_4_8_1_DataSummary() {
  const { t } = useTranslation();
  const { workplaceSummary } = useWfWorkplaceStore();
  const { getWorkplaceSummary } = useWfWorkplaceService();

  useEffect(() => {
    const loadSummary = async () => {
      try {
        await getWorkplaceSummary();
      } catch (error) {
        console.error('Failed to get workplace summary:', error);
      }
    };
    loadSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <DataTable
        noDataComponent={t('wf.common.noResults')}
        columns={getWfDataSummaryColumns(t)}
        data={workplaceSummary}
        customStyles={customStyles}
      />
    </div>
  );
}

export default WF_4_8_1_DataSummary;
